import React from 'react';
import { FiUsers, FiChevronDown } from 'react-icons/fi';
import { formatMoney } from '../utils/money';

export default function ContadorClientPicker({
  clients,
  activeCompanyId,
  onChange,
  modoOscuro,
  multiClient,
}) {
  if (!clients?.length) return null;

  const box = modoOscuro ? 'border-gray-800 bg-gray-900' : 'border-gray-200 bg-white';
  const textPri = modoOscuro ? 'text-white' : 'text-gray-900';
  const textMuted = modoOscuro ? 'text-gray-400' : 'text-gray-500';

  if (!multiClient) {
    const client = clients[0];
    return (
      <div className={`rounded-xl border px-4 py-3 flex items-center gap-3 ${box}`}>
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${
          modoOscuro ? 'bg-[#1F80FF]/20 text-[#5CA3FF]' : 'bg-[#1F80FF]/10 text-[#004AAD]'
        }`}>
          <FiUsers className="w-4 h-4" />
        </div>
        <div className="min-w-0">
          <div className={`text-sm font-semibold truncate ${textPri}`}>{client.companyName}</div>
          <div className={`text-xs ${textMuted}`}>{client.ownerName}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-xl border p-3 sm:p-4 ${box}`}>
      <label className={`block text-[10px] font-semibold uppercase tracking-wide mb-2 ${textMuted}`}>
        Cliente activo
      </label>
      <div className="relative">
        <select
          value={activeCompanyId}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full appearance-none rounded-lg border px-3 py-2.5 pr-9 text-sm font-medium ${
            modoOscuro
              ? 'border-gray-700 bg-gray-800 text-white'
              : 'border-gray-200 bg-white text-gray-900'
          }`}
        >
          {clients.map((c) => (
            <option key={c.companyId} value={c.companyId}>
              {c.companyName} — {c.impagasCount} impaga{c.impagasCount === 1 ? '' : 's'}
            </option>
          ))}
        </select>
        <FiChevronDown className={`absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none ${textMuted}`} />
      </div>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2">
        {clients.map((c) => {
          const active = c.companyId === activeCompanyId;
          return (
            <button
              key={c.companyId}
              type="button"
              onClick={() => onChange(c.companyId)}
              className={`text-left rounded-lg border px-3 py-2 transition-colors ${
                active
                  ? (modoOscuro ? 'border-[#1F80FF] bg-[#1F80FF]/10' : 'border-[#1F80FF] bg-[#1F80FF]/5')
                  : (modoOscuro ? 'border-gray-800 hover:bg-gray-800/60' : 'border-gray-100 hover:bg-gray-50')
              }`}
            >
              <div className={`text-xs font-semibold truncate ${textPri}`}>{c.companyName}</div>
              <div className={`text-[10px] mt-0.5 ${textMuted}`}>
                Impagas {formatMoney(c.impagasMonto, 'ARS')}
              </div>
              <div className={`text-[10px] ${textMuted}`}>
                Flujo mes {formatMoney(c.flujoMes, 'ARS')}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
